import { Grid, makeStyles, Paper, TextField } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import ContraSenhaComponent from '../atividade-servico/component/contra-senha-component';
import MenuComponent from '../components/menu/menu-component';
import authService from '../Services/auth/auth-service';
import { ACAO_CONTRA_SENHA, espiarRetornoFacialOS } from '../Services/biometria/etapa-facial-os';

const useStyles = makeStyles((theme) => ({
  paper: {
    borderRadius: 10,
    display: 'flex',
    padding: '15px 20px 25px',
    overflow: 'hidden',
    flexDirection: 'column',
  },
  tituloStyle: {
    fontFamily: 'Mont, sans-serif',
    color: '#209BDE',
    fontSize: '22px',
    textAlign: 'start',
    marginBottom: '5px',
  },
  subtituloStyle: {
    fontFamily: 'Mont, sans-serif',
    color: '#6C6C6C',
    fontSize: '15px',
    textAlign: 'start',
    marginTop: 0,
    marginBottom: '25px',
  },
  mensagemStyle: {
    fontFamily: 'Mont, sans-serif',
    color: '#6C6C6C',
    fontSize: '16px',
    textAlign: 'center',
  },
}));

export default function ContraSenhaPage() {
  const classes = useStyles();

  // Volta da validação facial da contra senha: a NA digitada se perde na ida ao front de biometria. Só espia a
  // pendência para restaurar a NA; quem consome o comprovante (uso único) e refaz a geração é o componente.
  const [na, setNa] = useState(() => espiarRetornoFacialOS(ACAO_CONTRA_SENHA)?.extra?.na || '');
  const [temPermissao, setTemPermissao] = useState(true);

  useEffect(() => {
    const usuarioInfo = authService.getUserInfo().usuario;
    const permissaoAgendaGlobal = usuarioInfo.permissaoUsuario;

    const empresa = usuarioInfo.empresa;
    const tecnico = usuarioInfo.tecnico;

    if (empresa || tecnico) {
      setTemPermissao(
        permissaoAgendaGlobal?.some((p) =>
          p.permissoesLista?.some((i) => i.trim() === 'cod_contrassenha')
        )
      );
    }
  }, []);

  return (
    <div>
      <MenuComponent />

      {temPermissao ? (
        <div style={{ margin: 30 }}>
          <h3 className={classes.tituloStyle}>Contrassenha</h3>
          <h4 className={classes.subtituloStyle}>
            Informe a NA para gerar a contrassenha. Use esta tela quando a NA já
            saiu da sua agenda. Depois do fechamento, a contrassenha sai apenas
            no mesmo dia e somente para o equipamento da própria NA.
          </h4>

          <Paper className={classes.paper}>
            <Grid container spacing={3}>
              <Grid xs={12} md={6} lg={4} item>
                <TextField
                  variant="outlined"
                  name="txtNa"
                  value={na}
                  onChange={(e) => setNa(e.target.value.trim())}
                  label={
                    <span>
                      NA <span style={{ color: 'red' }}>*</span>
                    </span>
                  }
                  placeholder="Número da NA"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>

            <div style={{ marginTop: 10 }}>
              <ContraSenhaComponent na={na} />
            </div>
          </Paper>
        </div>
      ) : (
        <div style={{ margin: 30 }}>
          <h3 className={classes.tituloStyle}>Contrassenha</h3>
          <h2 className={classes.mensagemStyle} style={{ padding: 5, paddingBottom: 20 }}>
            Você não tem permissão para acessar o contra senha!
          </h2>
        </div>
      )}
    </div>
  );
}
